/**
 * Generate random ID
 * @returns {string}
 */
export default function randomId() {
  return `n${(~~(Math.random() * 1e8)).toString(16)}`;
}
